function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Generated with Avocode.");

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Path 548"), /*#__PURE__*/React.createElement("path", {
  d: "M20.20081,9.59702l-7.40802,-7.408v0l-1.56299,-1.563c-0.52802,-0.528 -1.38397,-0.528 -1.91199,0l-1.56299,1.563v0l-7.40802,7.408c-0.50897,0.509 -0.50897,1.334 0,1.843l0.67603,0.67599c0.50897,0.509 1.33398,0.509 1.84296,0l5.69,-5.68999v0v17.727c0,0.661 0.53503,1.196 1.19501,1.196h1.04602c0.65997,0 1.19501,-0.535 1.19501,-1.196v-17.727v0l5.69,5.68999c0.50897,0.509 1.33398,0.509 1.84302,0l0.67596,-0.67599c0.50903,-0.509 0.50903,-1.334 0,-1.843z",
  fillOpacity: 1
})));

var SvgSendBlk = function SvgSendBlk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSendBlk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send_blk.652b4f0c.svg";
export { ForwardRef as ReactComponent };